import { useStore } from '../../../store/useStore';
import { useEffect, useState } from 'react';
import { achievements } from '../../../data/achievements';

export const AchievementToast = () => {
    const unlockedIds = useStore((state) => state.unlockedAchievementIds);
    const [currentToast, setCurrentToast] = useState<{ title: string; icon: string } | null>(null);

    useEffect(() => {
        // When unlockedIds changes, check if we have a new one to show
        // simple logic: just show the last one if it's new
        if (unlockedIds.length > 0) {
            const lastId = unlockedIds[unlockedIds.length - 1];
            const ach = achievements.find(a => a.id === lastId);
            if (ach) {
                setCurrentToast({ title: ach.title, icon: ach.icon });

                // Audio cue could go here

                const timer = setTimeout(() => {
                    setCurrentToast(null);
                }, 4000); // Show for 4 seconds
                return () => clearTimeout(timer);
            }
        }
    }, [unlockedIds.length]); // Only depend on length change to avoid re-triggering on same list re-render

    if (!currentToast) return null;

    return (
        <div style={{
            position: 'absolute',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(0, 0, 0, 0.8)',
            border: '2px solid #ffd700',
            borderRadius: '50px',
            padding: '10px 30px',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            zIndex: 2000,
            animation: 'slideDown 0.5s ease-out'
        }}>
            <span style={{ fontSize: '2em' }}>{currentToast.icon}</span>
            <div>
                <div style={{ fontSize: '0.8em', color: '#ffd700', textTransform: 'uppercase', letterSpacing: '1px' }}>Achievement Unlocked</div>
                <div style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{currentToast.title}</div>
            </div>
            <style>{`
                @keyframes slideDown {
                    from { transform: translate(-50%, -100%); opacity: 0; }
                    to { transform: translate(-50%, 0); opacity: 1; }
                }
            `}</style>
        </div>
    );
};
